export const REPLACE_ACCOUNT_STATS = 'REPLACE_ACCOUNT_STATS';

export const replaceAccountStats = stats => ({
  type: REPLACE_ACCOUNT_STATS,
  payload: stats,
});
